import { useState, useEffect } from "react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { DDD } from "../lib/ddd/ddd";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const useDashboardData = (clientsNo) => {
  const [isLoading, setIsLoading] = useState(null);
  const [data, setData] = useState(null);
  const [clients, setClients] = useState(null);

  const {isPending : tDataPending, data : tData} = useQuery({
    queryKey: ["EUeInvoices.GetCurrentTData"],
    queryFn: () => ddd.Rpc_ExecuteExtension("EUeInvoices.GetCurrentTData"),
  })
  const args = {
    Take : clientsNo
  }
  const {isPending : isCustomersPending, data : customerData} = useQuery({
    queryKey: ["EUeInvoices.GetTCustomers", args],
    queryFn: () => ddd.Rpc_ExecuteExtension("EUeInvoices.GetTCustomers"),
  })

  useEffect(() => {
    setIsLoading(true);
    if(!tDataPending && !isCustomersPending)
      setIsLoading(false);

    if(tData){
      setData(tData.result?.Result);
    }
    if(customerData){
      setClients(customerData.result?.Result);
    }
  }, [tDataPending, tData, isCustomersPending, customerData])

  /*useEffect(() => {
    setIsLoading(true);
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.GetCurrentTData",
          },
          id: 13,
        },
        { withCredentials: true }
      )
      .then((res) => {
        if (res.data.result) {
          setData(res.data.result.Result);
          // setConnKeyHandler(res.data.result.Result.ConnectionKeyTest);

          axios
            .post(
              apiRequestAddress,
              {
                jsonrpc: "2.0",
                method: "Extension.Execute",
                params: {
                  extension: "EUeInvoices.GetTCustomers",
                  args: {
                    Take: clientsNo,
                  },
                },
                id: 15,
              },
              {
                withCredentials: true,
              }
            )
            .then((clientsRes) => {
              setClients(clientsRes.data.result.Result);
              setIsLoading(false);
            });
        } else {
          setIsLoading(false);
        }
      });
  }, [clientsNo]);*/

  return { isLoading, data, clients };
};

export default useDashboardData;
